module.exports = __webpack_public_path__ + "img/pe.ce629061.svg";